import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Personvernerklæring | Strømkalkulator.no</title>
        <meta name="description" content="Personvernerklæring for Strømkalkulator.no - Les om hvordan vi behandler dine personopplysninger." />
      </Helmet>

      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto bg-white dark:bg-dark-card rounded-lg shadow-sm p-8 dark:border dark:border-dark-border">
          <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Personvernerklæring</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">1. Innledning</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Denne personvernerklæringen forklarer hvordan Strømkalkulator.no samler inn og bruker personopplysninger. 
              Vi er opptatt av å beskytte ditt personvern og behandler alle personopplysninger i samsvar med gjeldende personvernlovgivning.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">2. Informasjon vi samler inn</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">Vi samler inn følgende informasjon:</p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
              <li>Geografisk lokasjon (med ditt samtykke)</li>
              <li>Informasjon om strømforbruk (når du bruker kalkulatoren)</li>
              <li>Teknisk informasjon om enheten din og hvordan du bruker nettstedet</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">3. Bruk av informasjonskapsler (cookies)</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Vi bruker informasjonskapsler for å forbedre brukeropplevelsen og for å kunne tilby relevante annonser. 
              Dette inkluderer:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
              <li>Nødvendige cookies for nettstedets funksjonalitet</li>
              <li>Analysecookies for å forstå hvordan nettstedet brukes</li>
              <li>Annonseringscookies fra Google AdSense</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">4. Annonser</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Vi bruker Google AdSense for å vise annonser på nettstedet. Google AdSense bruker cookies og kan samle inn 
              informasjon om din bruk av nettstedet for å vise relevante annonser. Du kan lese mer om Google AdSense sin 
              personvernpolicy på <a href="https://policies.google.com/privacy" className="text-blue-600 hover:underline">Google's personvernside</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">5. Dine rettigheter</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">Du har rett til å:</p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
              <li>Be om innsyn i personopplysninger vi har om deg</li>
              <li>Be om retting eller sletting av personopplysninger</li>
              <li>Protestere mot behandling av personopplysninger</li>
              <li>Trekke tilbake samtykke til behandling av personopplysninger</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">6. Kontakt</h2>
            <p className="text-gray-700 dark:text-gray-300">
              Har du spørsmål om personvern, ta kontakt med oss på{' '}
              <a href="mailto:tor.jetix16@gmail.com" className="text-blue-600 hover:underline dark:text-blue-400">
                tor.jetix16@gmail.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicy;